(function () {
  function ensureAlmaInitialized(merchantId) {
    if (!window.Alma || !Alma.Widgets) return null;

    if (window.__almaWidgetsInstance) return window.__almaWidgetsInstance;

    try {
      window.__almaWidgetsInstance = Alma.Widgets.initialize(
        merchantId,
        Alma.ApiMode.LIVE
      );
      return window.__almaWidgetsInstance;
    } catch (e) {
      console.error("[Alma] initialize error", e);
      return null;
    }
  }

  function mountPaymentPlans(root) {
    // Prevent double-mount
    if (root.dataset.almaMounted === "1") return;

    const merchantId = root.dataset.almaMerchantId;
    const locale = root.dataset.almaLocale || "fr";
    const amountCents = parseInt(root.dataset.almaAmount || "0", 10);
    const containerEl = root.querySelector(".alma-payment-plans__container");

    if (!merchantId || !amountCents || !containerEl) return;

    // Make container addressable via selector string (most reliable)
    if (!containerEl.id) {
      containerEl.id = "alma-payment-plans-" + Math.random().toString(16).slice(2);
    }
    const containerSelector = "#" + containerEl.id;

    const widgets = ensureAlmaInitialized(merchantId);
    if (!widgets) return;

    // Clear previous render
    containerEl.innerHTML = "";

    try {
      widgets.add(Alma.Widgets.PaymentPlans, {
        container: containerSelector,
        purchaseAmount: amountCents,
        locale: locale,

        transitionDelay: 5500,
        hideBorder: false,
        hideIfNotEligible: true,
        monochrome: false,

        plans: [
          { installmentsCount: 2, minAmount: 5000, maxAmount: 500000 },
          { installmentsCount: 3, minAmount: 5000, maxAmount: 500000 },
        ],
      });

      root.dataset.almaMounted = "1";
    } catch (e) {
      console.error("[Alma] widgets.add error", e);
    }
  }

  function initAllExisting() {
    document.querySelectorAll(".alma-payment-plans").forEach(mountPaymentPlans);
  }

  function observeForLateInsertion() {
    const obs = new MutationObserver(() => {
      initAllExisting();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function hookVariantChanges() {
    function getVariantId() {
      const input = document.querySelector('form[action^="/cart/add"] [name="id"]');
      return input ? input.value : null;
    }

    async function fetchVariantPriceCents(variantId) {
      const res = await fetch(`/variants/${variantId}.js`, { credentials: "same-origin" });
      if (!res.ok) return null;
      const variant = await res.json();
      return typeof variant.price === "number" ? variant.price : null;
    }

    let lastVariantId = getVariantId();

    async function refreshAmountAndRemount() {
      const variantId = getVariantId();
      if (!variantId || variantId === lastVariantId) return;
      lastVariantId = variantId;

      const priceCents = await fetchVariantPriceCents(variantId);
      if (typeof priceCents !== "number") return;

      document.querySelectorAll(".alma-payment-plans").forEach((root) => {
        root.dataset.almaAmount = String(priceCents);
        root.dataset.almaMounted = "0";
        mountPaymentPlans(root);
      });
    }

    document.addEventListener("change", refreshAmountAndRemount);
  }

  function boot() {
    initAllExisting();
    observeForLateInsertion();
    hookVariantChanges();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
